import { render, staticRenderFns } from "./RecognizeInfo.vue?vue&type=template&id=1a8409ca&scoped=true"
import script from "./RecognizeInfo.vue?vue&type=script&lang=js"
export * from "./RecognizeInfo.vue?vue&type=script&lang=js"
import style0 from "./RecognizeInfo.vue?vue&type=style&index=0&id=1a8409ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8409ca",
  null
  
)

export default component.exports